import type { Address } from '@/data/types';

// Forward geocoding via Nominatim (OpenStreetMap) — free, no API key. Takes a
// full address and returns the single best-match coordinate, or null. Subject
// to the Nominatim usage policy (≤1 req/sec, no bulk); intended for occasional
// per-customer lookup on address save, not mass import.
export async function geocode(
  a: Address
): Promise<{ lat: number; lng: number } | null> {
  const q = [a.street, a.zip, a.city, a.country ?? 'CH']
    .filter(Boolean)
    .join(', ');
  if (!q) return null;
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        q
      )}&limit=1`,
      { headers: { Accept: 'application/json' } }
    );
    if (!res.ok) return null;
    const data = (await res.json()) as { lat: string; lon: string }[];
    if (!data.length) return null;
    return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
  } catch {
    return null;
  }
}
